import { defineStore, acceptHMRUpdate } from 'pinia';
import { storeConfig } from '@/shared/storeConfig';

import {
  handleRefreshToken,
  updateLastRefreshTokenDate,
} from '@/_cactus_core/ApiService/jwt';

const jwtStore = () => {
  const jwtTokenFromStore = ref<string>('');

  const jwtTokenFromCookie = useCookie('jwt_token', {
    default: () => '',
  });

  const accessToken = computed<string>({
    get() {
      const token = jwtTokenFromCookie.value || jwtTokenFromStore.value;

      try {
        handleRefreshToken(token);
      } catch (ex) {}

      return token;
    },

    set(value: string) {
      jwtTokenFromCookie.value = value;
      jwtTokenFromStore.value = value;
    },
  });

  function saveToken(token: string): void {
    accessToken.value = token;

    try {
      window.__crtc__ = true;
      updateLastRefreshTokenDate();
    } catch (ex) {}
  }

  function destroyToken(): void {
    accessToken.value = '';
  }

  function $reset() {
    accessToken.value = '';
  }

  return {
    $reset,
    accessToken,
    saveToken,
    destroyToken,
  };
};

export const useJwtStore = defineStore('jwt', jwtStore, storeConfig);

// @ts-ignore
if (import.meta.hot) {
  // @ts-ignore
  import.meta.hot.accept(acceptHMRUpdate(useJwtStore, import.meta.hot));
}
